/**
 * Note: back-end knows these as discounts while a decision was made
 * to call them promotions in the webapp.
 */

import { Field, ObjectType } from "./decorators";


@ObjectType()
export class PromoTemplateField {
  @Field() name!: string;
  @Field() value?: string | number | boolean | Date | null;
  @Field() type?: string; // string, number, boolean.   default is string.
}

@ObjectType()
export class PromoTemplateRestriction {
  @Field() entity!: string;
  @Field() operator!: string;
  @Field() property!: string;
  @Field() value!: string | number | boolean | null;
  @Field() inputId!: string; // where to get the value from on the input
}

@ObjectType()
export class PromoTemplateInputSubset {
  @Field() inputId!: string;
  @Field() label!: string;
  @Field() userInputValue?: string | number | boolean | Date;
  @Field() includeInConfirmation!: boolean;
}

@ObjectType()
export class PromoTemplateInput extends PromoTemplateInputSubset {
  @Field() type!: string;
  @Field() subtype?: string;
  @Field() maxLen?: number;
  @Field() min?: number;
  @Field() max?: number;
  @Field() chooser?: string;
  @Field() required!: boolean;
  @Field() choices?: string[]; // for a dropdown.
  @Field() defaultValue?: string | number | boolean;
}

@ObjectType()
export class PromoTemplateAction {
  @Field() action!: string;
  @Field() value!: string | number | boolean | null;
  @Field() inputId?: string; // where to get the value from on the input
}

@ObjectType()
export class PromotionTemplate<T> {
  @Field() template!: string;
  @Field() label?: string;
  @Field() description?: string;
  @Field() production!: boolean;
  @Field({ sub: () => PromoTemplateField }) fields!: PromoTemplateField[];
  @Field({ sub: () => PromoTemplateRestriction }) restrictions!: PromoTemplateRestriction[];
  @Field({ sub: () => PromoTemplateInput }) inputs!: T[];
  @Field({ sub: () => PromoTemplateAction }) actions!: PromoTemplateAction[];
}
